import { useCallback, useSyncExternalStore } from "react";
import { cardPreferenceKey, readCardPreferences, subscribeCardPreferences } from "components/custom-fields/incardPreference";
import useUser from "./useUser";
import useSelectedOrganization from "./useSelectedOrganization";

/** La preferenza "in card" e' per modello, non per processo: i processi di un
 * modello la ereditano. */
export default function useCardPreferences(modelId?: string | number) {
  const user = useUser();
  const organization = useSelectedOrganization();
  const key = user?.userId && organization?.id && modelId
    ? cardPreferenceKey(user.userId, organization.id, modelId) : "";
  return useSyncExternalStore(subscribeCardPreferences, useCallback(() => readCardPreferences(key), [key]));
}
